'use strict';

var MarketProductAnalysisGridDirective = function MarketProductAnalysisGridDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-product-analysis-grid.html'),
    controller: 'MarketProductAnalysisGridController',
    scope: {
      mode: '@',
      screen: '@',
      flowType: '@',
      filterData: '=',
      isDemandManagement: '=?',
      reoptPreviewData: '=',
      demandManagementData: '=',
      confirmAdjustmentsClearOnRefresh: '=?'
    }
  };
};
MarketProductAnalysisGridDirective.$inject = [];
module.exports = MarketProductAnalysisGridDirective;